import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { vuetifyIndexTableDefaults } from '@/shared/plugins/vuetifyIndexDefaults'
import {
  bindVuetifyTheme,
  createModuleThemes,
  defaultThemeName
} from '@/shared/plugins/themeVuetify'
import '@/shared/utils/disableNumberInputWheel'

export const lmsChartPalette = [
  '#00B4D8',
  '#2EC4B6',
  '#FF9F1C',
  '#E71D36',
  '#7B2CBF',
  '#06D6A0',
  '#FF6B6B',
  '#4CC9F0',
  '#F4A261',
  '#118AB2',
  '#EF476F',
  '#90BE6D',
  '#FFD166',
  '#F94144',
  '#43AA8B',
  '#577590',
  '#9B5DE5',
  '#00BBF9',
  '#F15BB5',
  '#FEE440',
  '#00F5D4',
  '#FB5607',
  '#3A86FF',
  '#8338EC'
]

const lmsThemes = createModuleThemes('lms', {
    background: '#F4F6F8',
    surface: '#FFFFFF',
    primary: '#0B7EA4',
    secondary: '#E8F4F8',
    success: '#2E7D32',
    warning: '#ED6C02',
    error: '#D32F2F',
    info: '#0B7EA4'
  })

const lmsVuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: defaultThemeName('lms'),
    themes: lmsThemes
  },
  defaults: {
    ...vuetifyIndexTableDefaults,
    VBtn: {
      rounded: 'md',
      style: 'border-radius: 6px; text-transform: uppercase; letter-spacing: 0.04em;'
    },
    VCard: {
      elevation: 0,
      rounded: 'lg'
    },
    VChip: {
      rounded: 'md'
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  }
})

bindVuetifyTheme(lmsVuetify, 'lms')

export default lmsVuetify
